"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAllAttributeValues = exports.getRequiredInputs = exports.getRuleSet = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _request = _interopRequireDefault(require("./request"));

var _AttributeSelectorUtils = require("./AttributeSelectorUtils");

var _util = require("./util");

var PREFERRED_NUMBER_OF_VALUES = 10;

var getDefaults = function getDefaults(values) {
  return values.length > PREFERRED_NUMBER_OF_VALUES ? values.slice(0, PREFERRED_NUMBER_OF_VALUES) : null;
};

var getRuleSet = function getRuleSet(sku, onGetAccessToken) {
  return (0, _request.default)("https://rule.products.cimpress.io/v1/ruleSets?referenceId=".concat(sku), onGetAccessToken);
};

exports.getRuleSet = getRuleSet;

var getRequiredInputs = function getRequiredInputs(sku, onGetAccessToken) {
  return (0, _request.default)("https://priceinput.ff.cimpress.io/api/v1/requiredinputs/".concat(sku), onGetAccessToken);
};

exports.getRequiredInputs = getRequiredInputs;

var pushToDefaults = function pushToDefaults(defaults, number) {
  if (defaults.length < PREFERRED_NUMBER_OF_VALUES) {
    defaults.push(number);
  }
};

var getMoq = function getMoq(inputRanges) {
  var moq = null;

  if (!(0, _util.isEmptyArray)(inputRanges)) {
    inputRanges.forEach(function (range) {
      moq = moq && moq < range.minimum ? moq : range.minimum;
    });
  }

  return moq;
};

var parseAttributes = function parseAttributes(name, inputValues, inputRanges, scope, allAttributeValues) {
  var lowerCaseName = name.toLowerCase(); // Value Attributes with more than 1 value

  if (!(0, _util.isEmptyArray)(inputValues) && inputValues.length > 1) {
    var values = inputValues.map(function (value) {
      return value.value;
    });
    var defaults = getDefaults(values);
    allAttributeValues[lowerCaseName] = {
      key: name,
      class: scope,
      values: values,
      defaults: defaults
    };
  } else if (!(0, _util.isEmptyArray)(inputRanges)) {
    var rangeFound = false;

    for (var i = 0; i < inputRanges.length; i += 1) {
      var range = inputRanges[i];

      if (range.increment) {
        rangeFound = true;
        break;
      }
    } // Ranged Attributes


    if (rangeFound) {
      var fixedValues = [];
      var ranges = [];
      var _defaults = [];
      var perRange = PREFERRED_NUMBER_OF_VALUES / inputRanges.length;
      perRange = perRange < 2 ? 2 : perRange;
      inputRanges.forEach(function (range) {
        var minimum = range.minimum,
            maximum = range.maximum,
            increment = range.increment;
        var currentAllocation = perRange;

        if (currentAllocation > 0 && !_defaults.includes(minimum)) {
          pushToDefaults(_defaults, minimum);
          currentAllocation -= 1;
        }

        if (maximum !== minimum) {
          if (maximum !== null) {
            ranges.push({
              minimum: minimum,
              maximum: maximum,
              increment: increment
            });

            if (currentAllocation > 0 && !_defaults.includes(maximum)) {
              pushToDefaults(_defaults, maximum);
              currentAllocation -= 1;
            }

            if (currentAllocation > 0) {
              var diff = (maximum - minimum) / perRange;
              var step = Math.round(diff / increment) * increment;
              var begin = minimum === 1 && step > 9 ? 0 : minimum;

              for (var _i = 1; _i <= currentAllocation; _i += 1) {
                var next = begin + _i * step;

                if (!_defaults.includes(next)) {
                  pushToDefaults(_defaults, next);
                }
              }
            }
          } else {
            ranges.push({
              minimum: minimum,
              maximum: 'infinity',
              increment: increment
            });

            for (var _i2 = 1; _i2 <= currentAllocation; _i2 += 1) {
              var _begin = minimum === 1 ? 0 : minimum;

              var _next = _begin + _i2 * 100;

              if (!_defaults.includes(_next)) {
                pushToDefaults(_defaults, _next);
              }
            }
          }
        } else {
          fixedValues.push(minimum);
        }
      });

      if (_defaults.length > 0) {
        _defaults = _defaults.sort(function (a, b) {
          return a - b;
        });
      } // Set toolTip text


      var toolTip = null;

      if (fixedValues.length > 0) {
        fixedValues = fixedValues.sort(function (a, b) {
          return a - b;
        });
        toolTip = "Must be ".concat(fixedValues.join(','), "\n");
      }

      if (ranges.length > 0) {
        if (toolTip) {
          toolTip += 'or must be between\n';
        } else {
          toolTip = 'Must be between\n';
        }

        var rangeTexts = [];
        ranges = ranges.sort(function (a, b) {
          return a.minimum === b.minimum ? a.maximum - b.maximum : a.minimum - b.minimum;
        });
        ranges.forEach(function (range) {
          var minimum = range.minimum,
              maximum = range.maximum,
              increment = range.increment;
          rangeTexts.push("".concat(minimum, " and ").concat(maximum, " in increments of ").concat(increment));
        });
        toolTip += rangeTexts.join(',\n');
      }

      allAttributeValues[lowerCaseName] = {
        key: name,
        class: scope,
        defaults: _defaults,
        isRange: true,
        values: {
          ranges: ranges,
          fixedValues: fixedValues
        },
        toolTip: toolTip
      };
    } // Ranged Attributes that are really value attributes (With more than 1 value)
    else if (inputRanges.length > 1) {
        var _values = inputRanges.map(function (range) {
          return range.minimum;
        }).sort(function (a, b) {
          return a - b;
        });

        var _defaults2 = getDefaults(_values);

        allAttributeValues[lowerCaseName] = {
          key: name,
          class: scope,
          values: _values,
          defaults: _defaults2
        };
      }
  }
};

var getAllAttributeValues =
/*#__PURE__*/
function () {
  var _ref = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee(sku, onGetAccessToken) {
    var moq, allAttributeValues, ruleSetPromise, requiredInputsPromise, combinedResult, _combinedResult, ruleSetResponse, requiredInputs, ruleSet, derivedAttributes, requiredAttributes, ruleSetInfo;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            moq = null;
            allAttributeValues = {};
            ruleSetPromise = getRuleSet(sku, onGetAccessToken);
            requiredInputsPromise = getRequiredInputs(sku, onGetAccessToken);
            _context.next = 6;
            return Promise.all([ruleSetPromise, requiredInputsPromise]);

          case 6:
            combinedResult = _context.sent;
            _combinedResult = (0, _slicedToArray2.default)(combinedResult, 1), ruleSetResponse = _combinedResult[0];
            requiredInputs = combinedResult[1];
            ruleSet = ruleSetResponse.find(function (item) {
              return item.authoritative;
            });
            requiredInputs = requiredInputs.inputs ? requiredInputs.inputs : null;

            if (!(!ruleSet || !requiredInputs)) {
              _context.next = 13;
              break;
            }

            return _context.abrupt("return", null);

          case 13:
            derivedAttributes = {};
            requiredAttributes = {};

            if (ruleSet) {
              requiredInputs = requiredInputs.filter(function (item) {
                var name = item.name;
                name = name.toLowerCase();
                var result = (0, _AttributeSelectorUtils.findAttributeDependencies)(name, ruleSet);

                if (result && result.length > 1 && !derivedAttributes[name]) {
                  derivedAttributes[name] = 1;
                  result.forEach(function (value) {
                    var lowerCaseValue = value.toLowerCase();

                    if (lowerCaseValue !== name && !requiredAttributes[lowerCaseValue]) {
                      requiredAttributes[lowerCaseValue] = 1;
                    }
                  });
                  return false;
                }

                return true;
              });
            }

            if (!(0, _util.isEmptyArray)(requiredInputs)) {
              requiredInputs.forEach(function (item) {
                var name = item.name,
                    inputValues = item.inputValues,
                    inputRanges = item.inputRanges,
                    scope = item.scope;
                var lowerCaseName = name.toLowerCase();

                if (lowerCaseName === 'quantity') {
                  moq = getMoq(inputRanges);
                }

                if (!allAttributeValues[lowerCaseName]) {
                  parseAttributes(name, inputValues, inputRanges, scope, allAttributeValues);
                }
              });
            }

            if (ruleSet && !(0, _util.isEmptyArray)(ruleSet.whiteList)) {
              ruleSet.whiteList.forEach(function (item) {
                var attributeKey = item.attributeKey,
                    attributeValues = item.attributeValues,
                    attributeRanges = item.attributeRanges;
                var lowerCaseName = attributeKey.toLowerCase();

                if (lowerCaseName === 'quantity') {
                  moq = getMoq(attributeRanges);
                }

                if (!allAttributeValues[lowerCaseName] && requiredAttributes[lowerCaseName]) {
                  parseAttributes(attributeKey, attributeValues, attributeRanges, item.class, allAttributeValues);
                }
              });
            }

            requiredInputs.forEach(function (input) {
              var name = input.name,
                  scope = input.scope;
              var inputValues = input.inputValues;
              var lowerCaseAttributeKey = name.toLowerCase();
              inputValues = inputValues.map(function (item) {
                return item.value;
              });

              if (!allAttributeValues[lowerCaseAttributeKey] && inputValues && inputValues.length > 1) {
                var defaults = getDefaults(inputValues);
                allAttributeValues[lowerCaseAttributeKey] = {
                  key: name,
                  class: scope,
                  values: inputValues,
                  defaults: defaults
                };
              }
            });
            derivedAttributes = Object.keys(derivedAttributes);
            ruleSetInfo = {
              moq: moq,
              ruleSet: ruleSet,
              derivedAttributes: derivedAttributes,
              allAttributeValues: allAttributeValues,
              requiredInputs: requiredInputs
            };
            return _context.abrupt("return", (0, _defineProperty2.default)({}, sku, ruleSetInfo));

          case 22:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function getAllAttributeValues(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

exports.getAllAttributeValues = getAllAttributeValues;